"use client";

import { CATEGORY_IMAGES, CATEGORY_LABELS, PRIZE_CATEGORIES, type PrizeCategory } from "../../lifestyle-constants";
import CategoryCard from "./CategoryCard";

interface CategoryGridProps {
  /** Matches the aria-controls of the tab that opens this panel. */
  id?: string;
  selectedCategory: PrizeCategory | null;
  /** Prize counts per category slug, used to grey out empty categories. */
  categoryCounts: Map<string, number>;
  onSelect: (category: PrizeCategory | null) => void;
  className?: string;
}

/**
 * The Categories panel: one illustrated tile per category plus an outlined
 * "All prizes" tile that clears the category filter. Four across on desktop,
 * two on mobile, so the tiles stay square without a fixed width.
 */
export default function CategoryGrid({
  id,
  selectedCategory,
  categoryCounts,
  onSelect,
  className = "",
}: CategoryGridProps) {
  return (
    <div
      id={id}
      role={id ? "tabpanel" : undefined}
      aria-hidden={id ? undefined : true}
      className={`grid grid-cols-2 lg:grid-cols-4 gap-3 ${className}`}>
      {PRIZE_CATEGORIES.map(category => {
        const isSelected = category === selectedCategory;

        return (
          <CategoryCard
            key={category}
            label={CATEGORY_LABELS[category]}
            image={CATEGORY_IMAGES[category]}
            isSelected={isSelected}
            isDisabled={!isSelected && (categoryCounts.get(category) ?? 0) === 0}
            onSelect={() => onSelect(isSelected ? null : category)}
          />
        );
      })}

      <CategoryCard label="All prizes" isSelected={selectedCategory === null} onSelect={() => onSelect(null)} />
    </div>
  );
}
